import React, {Component} from 'react';
import StickyBox from "react-sticky-box";
import './sidebar.scss';

class SidebarLayout extends Component {

    constructor(props) {
        super(props)
    }

    render = () => {
        const {position} = this.props;
        return (
            <div className={'sidebar'} style={{boxShadow: '0 0 10px hsl(0deg 0% 50% / 30%)'}}>
                <StickyBox offsetTop={20} offsetBottom={20}>
                    <div className={`sidebar-inner`}>
                        <aside className={`sidebar-wrap`}>
                            <div className={`inner`}>
                                <section className="widget widget_categories">
                                    <h4 className="widget-title text-uppercase">Apartment Details</h4>
                                    <ul>
                                        <li className="cat-item">
                                            <a href="#">Price</a><span className="count">(20)</span>
                                        </li>
                                        <li className="cat-item">
                                            <a href="#">Area(m2)</a><span className="count">(4)</span>
                                        </li>
                                        <li className="cat-item">
                                            <a href="#">Floor</a><span className="count">(5)</span>
                                        </li>
                                        <li className="cat-item">
                                            <a href="#">Ceiling height</a><span className="count">(8)</span></li>
                                        <li className="cat-item">
                                            <a href="#">Bedrooms</a><span className="count">(7)</span>
                                        </li>
                                    </ul>
                                </section>
                                {/*<WigetBlogRecent/>*/}
                            </div>
                        </aside>
                    </div>
                </StickyBox>
            </div>
        )
    }
}

export default SidebarLayout
